import type {
    SearchCommerceCustomerSponsorsRequest,
    SearchCommerceCustomerSponsorsResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";

export const searchCommerceCustomerSponsorsOperation = defineCommerceOperation<
    SearchCommerceCustomerSponsorsRequest,
    SearchCommerceCustomerSponsorsResponse
>("commerce.customer.sponsor.search");
